import { CommonEnums } from "../../enums/common.enums";
import { EnvVariables } from "../../enums/env.variables.enums";

export class CommonHelpers {
  static isAgentRoute = (params: { path: string }) => {
    if (params.path.includes(CommonEnums.roles.agent)) return true;
    return false;
  };

  static isAgencyRoute = (params: { path: string }) => {
    if (params.path.includes(CommonEnums.roles.agency)) return true;
    return false;
  };

  static getImageUrlFromImageTool = (params: { path: string }) => {
    return `${EnvVariables.designToolEndpoint}/design-tool/images/${params.path}`;
  };

  static getPropertyAddress = ({
    no,
    streetName,
    city,
    state,
    country,
    postCode,
  }: {
    no: string;
    streetName: string;
    city: string;
    state: string;
    country: string;
    postCode: string;
  }) => {
    let address = "";

    address = `${streetName}, ${city}, ${state}, ${postCode}`;

    if (no) {
      address = `${no.toString().trim()} ${address}`;
    }

    return address;
  };
}
